import React from "react";
import { useLocation, useNavigate } from "react-router";
import SelectOption from "../SelectOption";
import Box from "../Box";
import { SingleValue } from "react-select";
import styled from "styled-components";
import { Choice } from "../../types/commercial";
import { useOptionCommercial } from "../../utils/options";
import { useKpiVisibility } from "../../kpis/useKpiVisibility";
import { useRange } from "../../context/rangeContext";
import useBreakPoint from "../../utils/useBreakPoint";
import { isEmailInWhitelist } from "../../utils/whiteListUtils";
import { useAuth } from "../../Auth/AuthProvider";
import useLandscape from "../../utils/useLandscape";

type LayoutProps = {
  children: React.ReactNode;
};

const BoxContainer = styled(Box)`
  gap: ${(props) => `${props.theme.space?.[2]}px`};
`;

/**
 * Composant interne du layout commercial
 */
const CommercialLayoutContent = ({ children }: LayoutProps) => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const optionCommercial = useOptionCommercial();
  const { hasKpis } = useKpiVisibility();
  const { setKpiRange } = useRange();
  const currentView = useBreakPoint();
  const isLandscape = useLandscape();
  const isMobilePortrait = currentView === "phone" && !isLandscape;

  const handleChange = (choice: SingleValue<Choice>) => {
    const newValue = choice?.value as string;

    if (newValue === location.pathname) {
      return;
    }
    const selectedOption = optionCommercial.find((opt: any) => opt.value === newValue);
    if (!!selectedOption) {
      setKpiRange("kpi_commercial", selectedOption.range);
    }
    navigate(newValue);
  };

  return (
    <>
      {hasKpis("Commercial") && ( 
        <BoxContainer
          width={"100%"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
        >
         { (!isEmailInWhitelist("ECOMMERCE_NEW_IHM_WHITE_LIST", user) || isMobilePortrait) && (
          <Box>
            <SelectOption
              list={optionCommercial}
              value={location?.pathname}
              handleChange={handleChange}
            />
          </Box> 
          )}
          {children}
        </BoxContainer>
      )}
    </>
  );
};

/**
 * Layout commercial
 */
const CommercialLayout = ({ children }: LayoutProps) => {
  return <CommercialLayoutContent>{children}</CommercialLayoutContent>;
};

export default CommercialLayout;
